<ion-header>
    <ion-toolbar color="light" no-border-bottom>
        <ion-title>{{ 'APP.TITLE.Credits' | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-grid>
        <ion-row>
            <ion-col class="text-center">
                <div class="credits-header">
                    <img src="assets/images/logo/logo.png" alt="ONAM"><br>
                </div>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col class="text-center">
                <p text-uppercase>{{ 'APP.ABOUT.DevelopedBy' | translate }}</p>
                <p><img src="assets/images/logo/mindoox.png" alt="MINDOOX" style="width: 30px; vertical-align: middle;"> MINDOOX Srl</p>
                <!-- <p><img src="assets/images/logo/@AT-90.png" alt="AT@" style="width: 30px; vertical-align: middle;"> Alfonso Tatarelli</p> -->
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>
